import { Box, Typography, Alert } from "@mui/material";
import { useUserContext } from "../../context/User/useUserContext";
import { TopicsAdmin } from "../Social/components/Topics/TopicsAdmin";

export const NewsSettings = () => {
    const { user } = useUserContext();

    // Check if user has admin role - roles is an array of strings
    const isAdmin = user?.roles?.includes("ROLE_ADMIN") || user?.roles?.includes("ROLE_SUPER_ADMIN");

    if (!isAdmin) {
        return (
            <Box p={3}>
                <Typography variant="h4" gutterBottom>
                    News Feed - Settings
                </Typography>
                <Alert severity="warning">You must be an administrator to access this page.</Alert>
            </Box>
        );
    }

    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom>
                News Feed - Settings
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
                Manage topics and configuration for the News Feed module.
            </Typography>

            <TopicsAdmin />
        </Box>
    );
};
